webpackJsonp([1],{

/***/ "/EEw":
/***/ (function(module, exports) {

module.exports = {"name":"hemostasis","label":"Hemostasia","fields":[{"name":"quick","label":"Tiempo de Protrombina (Quick) seg.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"10 – 15"},{"name":"prothrombin_concentration","label":"Concentración de Protrombina %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 120"},{"name":"rin","label":"R.I.N.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"0.80 – 1.2"},{"name":"aptt","label":"aPTT seg.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"28 – 42"},{"name":"ttd","label":"T.T.D seg.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"10 – 14"},{"name":"fibrinogen","label":"Fibrinógeno gr/L.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"1,8 – 4.2"},{"name":"ff5","label":"Factor V Funcional %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 120"},{"name":"dimer_d","label":"Dímero D ng UEF/mL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 500"},{"name":"pdf","label":"P.D.F. µg/dL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 5"},{"name":"ff8","label":"Factor VIII Funcional %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"75 – 120"},{"name":"VW_fa","label":"Factor Von Willebrand antigénico %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"o":"40 – 130","other":"60 – 150"}},{"name":"co_factor_ristocetin","label":"Co Factor de Ristocetina %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"o":"50 – 140","other":"65 – 180"}},{"name":"complex_2_7_9_10","label":"Complejo II, VII, IX, X","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"75 – 120"},{"name":"hematocrit","label":"Hematócrito %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"42 – 48","female":"37 – 44"}},{"name":"hemoglobin","label":"Hemoglobina grs/dL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"13,5 – 16,5","female":"12 – 15"}},{"name":"yield_platelets","label":"Rto. Plaquetas x 10<sup>3</sup>/µL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"170 – 420"},{"name":"euglobulins_lysis_time","label":"Tiempo de lisis de euglobulinas","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"> 2 hrs"},{"type":"title","name":"regular_blood_plasma_correction","label":"Corrección con plasma normal"},{"name":"regular_blood_plasma_correction_quick","label":"Tiempo de Protrombina (Quick) seg.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"10 – 15"},{"name":"regular_blood_plasma_correction_aptt","label":"aPTT seg.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"28 – 42"},{"name":"regular_blood_plasma_correction_ttd","label":"T.T.D seg.","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"10 – 14"},{"name":"regular_blood_plasma_correction_ff5","label":"Factor V Funcional %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 120"},{"name":"regular_blood_plasma_correction_complex_2_7_9_10","label":"Complejo II, VII, IX, X","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"75 – 120"}]}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0x+F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1eM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      error: ''
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])('auth', { loading: 'isAuthenticatePending' })),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('auth', ['authenticate']), {
    signIn: function signIn() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var username, password;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                username = _this.username, password = _this.password;
                _context.prev = 1;
                _context.next = 4;
                return _this.authenticate({ strategy: 'local', username: username, password: password });

              case 4:
                _this.$router.push({ name: 'App' });
                _context.next = 18;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);
                _context.t1 = _context.t0.message.toLowerCase();
                _context.next = _context.t1 === 'missing credentials' ? 12 : _context.t1 === 'invalid login' ? 14 : 16;
                break;

              case 12:
                _this.error = 'No introdujo usuario o contraseña';
                return _context.abrupt('break', 17);

              case 14:
                _this.error = 'Usuario o contraseña incorrecto';
                return _context.abrupt('break', 17);

              case 16:
                _this.error = 'Error desconocido';

              case 17:
                throw _context.t0.message;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 7]]);
      }))();
    }
  }),

  watch: {
    username: function username() {
      this.error = '';
    },
    password: function password() {
      this.error = '';
    }
  }
});

/***/ }),

/***/ "39ur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['section', 'printContent', 'displaySnack', 'snackMessage']), {
    isSignIn: function isSignIn() {
      return this.section === 'sign-in';
    },
    isStudyList: function isStudyList() {
      return this.section === 'study-list';
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])({ logout: 'auth/logout' }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])(['setPrintContent']), {
    createStudy: function createStudy() {
      this.$router.push({ name: 'NewStudy' });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    exit: function exit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.logout();

              case 2:
                _this.$router.replace({ name: 'SignIn' });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }),

  watch: {
    printContent: function printContent(value) {
      var _this2 = this;

      var _$refs$printFrame$con = this.$refs.printFrame.contentWindow,
          document = _$refs$printFrame$con.document,
          print = _$refs$printFrame$con.print;

      var body = document.querySelector('body');
      body.innerHTML = value;

      if (value) {
        document.querySelector('img').onload = function () {
          setTimeout(function () {
            print();
            _this2.setPrintContent('');
          }, 1000);
        };
      }
    }
  }
});

/***/ }),

/***/ "5OJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['field', 'formType', 'model'],

  computed: {
    isInput: function isInput() {
      return this.field.type === 'input' || this.field.type === 'textarea';
    },
    isTextArea: function isTextArea() {
      return this.field.type === 'textarea';
    },
    isSelect: function isSelect() {
      return this.field.type === 'select';
    },
    isTitle: function isTitle() {
      return this.field.type === 'title' || this.field.type === 'title-input';
    }
  },

  methods: {
    validate: function validate() {
      if (!this.field.pattern) return true;
      var pattern = new RegExp(this.field.pattern);

      if (!pattern.test(this.model[this.field.name]) && this.model[this.field.name]) {
        return 'Formato incorrecto';
      }

      return true;
    }
  }
});

/***/ }),

/***/ "67Lx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_findindex__ = __webpack_require__("etT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_findindex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_findindex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_study_types__ = __webpack_require__("pnYW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_study_print__ = __webpack_require__("L5/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mixins_study_send__ = __webpack_require__("wb2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_study_form__ = __webpack_require__("W+0h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_schemas_anemia_json__ = __webpack_require__("p0zs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_schemas_anemia_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__form_schemas_anemia_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__form_schemas_anticoagulation_json__ = __webpack_require__("8yBn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__form_schemas_anticoagulation_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__form_schemas_anticoagulation_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__form_schemas_compatibility_json__ = __webpack_require__("TneL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__form_schemas_compatibility_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__form_schemas_compatibility_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__form_schemas_hemostasis_json__ = __webpack_require__("/EEw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__form_schemas_hemostasis_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__form_schemas_hemostasis_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_schemas_myelogram_json__ = __webpack_require__("CvK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_schemas_myelogram_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__form_schemas_myelogram_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__form_schemas_thrombophilia_json__ = __webpack_require__("zYdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__form_schemas_thrombophilia_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__form_schemas_thrombophilia_json__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










// Schemas







var resultHasId = function resultHasId(result) {
  return result && result._id;
}; // eslint-disable-line


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'study',

  beforeRouteLeave: function beforeRouteLeave(from, to, next) {
    this.clearStudy();
    next();
  },
  data: function data() {
    return {
      study: {
        patient: {},
        results: [],
        studies: {}
      },
      nextProtocol: null,
      patients: [],
      formattedDate: null,
      patientSearchQuery: null,
      currentForm: null,
      studyDate: null,
      formSchemas: {
        anemia: __WEBPACK_IMPORTED_MODULE_15__form_schemas_anemia_json___default.a,
        anticoagulation: __WEBPACK_IMPORTED_MODULE_16__form_schemas_anticoagulation_json___default.a,
        compatibility: __WEBPACK_IMPORTED_MODULE_17__form_schemas_compatibility_json___default.a,
        hemostasis: __WEBPACK_IMPORTED_MODULE_18__form_schemas_hemostasis_json___default.a,
        myelogram: __WEBPACK_IMPORTED_MODULE_19__form_schemas_myelogram_json___default.a,
        thrombophilia: __WEBPACK_IMPORTED_MODULE_20__form_schemas_thrombophilia_json___default.a
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _ref, seq;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_14__api__["a" /* default */].service('counter').get('studyId');

            case 2:
              _ref = _context.sent;
              seq = _ref.seq;

              _this.nextProtocol = seq;
              _this.init(_this.$route);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  components: {
    studyForm: __WEBPACK_IMPORTED_MODULE_13__components_study_form__["a" /* default */]
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["e" /* mapState */])('patient', {
    loading: 'isFindPending'
  }), {
    isEditing: function isEditing() {
      return !!this.study._id; // eslint-disable-line
    },
    protocol: function protocol() {
      return this.study.protocol ? this.study.protocol : this.nextProtocol;
    },
    requestedStudies: function requestedStudies() {
      var studies = this.study.studies;


      return studies.anemia || studies.anticoagulation || studies.compatibility || studies.hemostasis || studies.myelogram || studies.thrombophilia;
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapMutations */])(['setPrintContent']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('study', {
    getStudy: 'get',
    createStudy: 'create',
    patchStudy: 'patch'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('result', {
    createResult: 'create',
    patchResult: 'patch'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapActions */])('patient', {
    findPatient: 'find'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapMutations */])(['showSnack']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["d" /* mapMutations */])('study', {
    clearStudy: 'clearCurrent'
  }), {
    cancel: function cancel() {
      this.$router.push({ name: 'StudyList' });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format('MMM DD, YYYY');
    },
    searchPatients: function searchPatients() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var query, _ref2, data;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                query = { $search: _this2.patientSearchQuery };
                _context2.next = 4;
                return _this2.findPatient({ query: query });

              case 4:
                _ref2 = _context2.sent;
                data = _ref2.data;

                _this2.patients = [_this2.study.patient].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(data));
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw _context2.t0;

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9]]);
      }))();
    },
    save: function save() {
      var _this3 = this;

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.study.patient) === '{}') {
        this.showSnack('No se seleccionó un paciente');
        throw new Error('No se seleccionó un paciente');
      }

      if (!this.requestedStudies) {
        this.showSnack('No se seleccionaron estudios');
        throw new Error('No se seleccionaron estudios');
      }

      if (this.isEditing) {
        var resultsToCreate = this.study.results.filter(function (result) {
          return !resultHasId(result);
        });
        var resultsToUpdate = this.study.results.filter(function (result) {
          return resultHasId(result);
        });

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(resultsToUpdate.map(function (result) {
          var _id = result._id;

          return _this3.patchResult([_id, result]);
        })), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(resultsToCreate.map(function (result) {
          return _this3.createResult(result);
        })))).then(function (results) {
          var _id = _this3.study._id;

          _this3.study.results = results;
          return _this3.patchStudy([_id, _this3.study]);
        }).then(function () {
          _this3.showSnack('Estudio guardado');
          _this3.$router.push({ name: 'StudyList' });
        }).catch(function (e) {
          _this3.showSnack('Falló al guardar el estudio');
          throw e;
        });
      } else {
        this.createStudy(this.study).then(function () {
          _this3.showSnack('Estudio creado');
          _this3.$router.push({ name: 'StudyList' });
        }).catch(function (e) {
          _this3.showSnack('Falló al guardar el estudio');
          throw e;
        });
      }
    },
    setForm: function setForm(form) {
      this.currentForm = form;
    },
    setFormValues: function setFormValues(name) {
      var formValues = this.study.results.filter(function (form) {
        return form.type === name;
      });

      return formValues[0] ? formValues[0].data : {};
    },
    init: function init(route) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var id;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = route.params.id;

                if (!id) {
                  _context3.next = 18;
                  break;
                }

                _context3.prev = 2;
                _context3.next = 5;
                return _this4.getStudy(id);

              case 5:
                _this4.study = _context3.sent;

                _this4.formattedDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this4.study.date).format('MMM DD, YYYY');
                _this4.patients.push(_this4.study.patient);

                _this4.studyDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()(_this4.study.date);

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.study.studies).forEach(function (study) {
                  _this4.studyTypes[study].selected = _this4.study.studies[study];
                });
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.study.studies).some(function (study) {
                  return _this4.study.studies[study] ? _this4.setForm(study) : null;
                });
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](2);
                throw _context3.t0;

              case 16:
                _context3.next = 19;
                break;

              case 18:
                _this4.study = {
                  patient: {},
                  results: [],
                  studies: {}
                };

              case 19:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[2, 13]]);
      }))();
    }
  }),

  mixins: [__WEBPACK_IMPORTED_MODULE_10__mixins_study_types__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_study_print__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__mixins_study_send__["a" /* default */]],

  watch: {
    $route: function $route(to) {
      this.init(to);
    },
    patientSearchQuery: function patientSearchQuery(value) {
      if (value && value.length >= 3) {
        this.searchPatients();
      }
    },
    currentForm: function currentForm(type) {
      if (__WEBPACK_IMPORTED_MODULE_9_lodash_findindex___default()(this.study.results, { type: type }) < 0) {
        this.study.results.push({
          data: {},
          study: this.study._id, // eslint-disable-line
          type: type
        });
      }

      this.study.results = this.study.results.filter(function (result) {
        return result !== null;
      });
    },
    studyDate: function studyDate() {
      this.study.date = __WEBPACK_IMPORTED_MODULE_8_moment___default()(this.studyDate);
    }
  }
});

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8QQJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d96cde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("8u0X");
function injectStyle (ssrContext) {
  __webpack_require__("in8c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43d96cde_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8fPx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_field_vue__ = __webpack_require__("5OJY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69907b53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_form_field_vue__ = __webpack_require__("G2sO");
function injectStyle (ssrContext) {
  __webpack_require__("hCJP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69907b53_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_form_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8u0X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"row"}},[_c('v-flex',{attrs:{"xs8":"xs8","offset-xs2":"offset-xs2"}},[_c('v-card',{staticClass:"elevation-1 card--flex-toolbar"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8yBn":
/***/ (function(module, exports) {

module.exports = {"name":"anticoagulation","label":"Anticoagulación","fields":[{"name":"quick","label":"Tiempo de Protrombina (Quick) seg.","reference":"10 – 15","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor"},{"name":"rin","label":"R.I.N.","reference":"0.8 – 1.2","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor"},{"name":"aptt","label":"aPTT seg.","reference":"28 – 42","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor"},{"name":"complex_2_7_9_10","label":"Complejo II, VII, IX, X","reference":"70 – 120","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor"}]}

/***/ }),

/***/ "Arnv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sign_in_vue__ = __webpack_require__("1eM5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6047c1d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_sign_in_vue__ = __webpack_require__("dyCW");
function injectStyle (ssrContext) {
  __webpack_require__("0x+F")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sign_in_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6047c1d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_sign_in_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CBq/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:_vm.section},[(!_vm.isSignIn)?_c('v-toolbar',{staticClass:"dark light-blue lighten-2",attrs:{"extended":"extended","fixed":"fixed","flat":"flat"}},[_c('v-fab-transition',[(!_vm.isStudyList)?_c('v-btn',{attrs:{"icon":"icon"},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e()],1),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.exit($event)}}},[_c('v-icon',[_vm._v("exit_to_app")])],1),_c('v-fab-transition',[(_vm.isStudyList)?_c('v-btn',{staticClass:"pink lighten-2",attrs:{"fab":"fab","dark":"dark","absolute":"absolute","bottom":"bottom","right":"right"},on:{"click":_vm.createStudy}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1)],1):_vm._e(),_c('main',[_c('v-container',{attrs:{"fluid":"fluid"}},[_c('router-view')],1)],1),_c('v-snackbar',{attrs:{"bottom":"bottom","left":"left"},model:{value:(_vm.displaySnack),callback:function ($$v) {_vm.displaySnack=$$v},expression:"displaySnack"}},[_vm._v(_vm._s(_vm.snackMessage))]),_c('iframe',{ref:"printFrame",staticClass:"printFrame"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CvK2":
/***/ (function(module, exports) {

module.exports = {"name":"myelogram","label":"Mielograma Descriptivo","fields":[{"name":"procedure","label":"Procedimiento","type":"textarea","placeholder":"Ingrese un valor"},{"name":"microscopy","label":"Microscopía","type":"textarea","placeholder":"Ingrese un valor"},{"name":"myelopoietic_series","label":"Serie Mielopoyética","type":"textarea","placeholder":"Ingrese un valor"},{"name":"erythropoietic_series","label":"Serie Eritropoyética","type":"textarea","placeholder":"Ingrese un valor"},{"name":"thrombopoietic_series","label":"Serie Trombopoyética","type":"textarea","placeholder":"Ingrese un valor"},{"name":"reticular_lymphocytic_plasma_series","label":"Series Reticular, Linfocitaria y Plasmática","type":"textarea","placeholder":"Ingrese un valor"},{"name":"mieloerythroid_ratio","label":"Relación Mielo-eritroide","type":"textarea","placeholder":"Ingrese un valor"},{"label":"Citoquímica","type":"title"},{"name":"hemosiderina","label":"Hemosiderina","type":"input","placeholder":"Ingrese un valor"},{"name":"sideroblasts","label":"Sideroblastos","type":"input","placeholder":"Ingrese un valor"},{"name":"peroxidase","label":"Peroxidasa","type":"input","placeholder":"Ingrese un valor"},{"name":"pas","label":"PAS","type":"input","placeholder":"Ingrese un valor"}]}

/***/ }),

/***/ "FDdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_form_field__ = __webpack_require__("8fPx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { formField: __WEBPACK_IMPORTED_MODULE_0__components_form_field__["a" /* default */] },

  data: function data() {
    return {
      comments: {
        name: 'comments',
        label: 'Comentarios',
        type: 'textarea'
      },
      conclusion: {
        name: 'conclusion',
        label: 'Conclusión',
        type: 'textarea'
      }
    };
  },


  props: {
    form: {
      type: Object,
      required: true
    },
    values: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
});

/***/ }),

/***/ "FKt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"study-list"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"card","prominent":"prominent"}},[_c('v-toolbar-title',{staticClass:"light-blue--text subheading"},[_vm._v("Libro de Entradas")]),_c('v-spacer'),(!_vm.mustShowSearch)?_c('v-btn',{attrs:{"icon":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.toggleSearch($event)}}},[_c('v-icon',[_vm._v("search")])],1):_vm._e(),(_vm.mustShowSearch)?_c('v-text-field',{ref:"search",staticClass:"search-input",attrs:{"name":"search","label":"Buscar estudio…","single-line":"single-line","autofocus":"autofocus"},on:{"blur":_vm.toggleSearch,"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getStudies($event)}},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}}):_vm._e(),(_vm.mustShowSearch)?_c('v-btn',{attrs:{"icon":"icon"},on:{"click":function($event){$event.preventDefault();return _vm.clearSearch($event)}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e()],1),(!_vm.loading)?_c('v-data-table',{attrs:{"hide-actions":"hide-actions","no-data-text":"No se encontraron estudios","headers":_vm.table.headers,"items":_vm.studies,"pagination":_vm.table.pagination},on:{"update:pagination":function($event){_vm.$set(_vm.table, "pagination", $event)}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{ noOrder: _vm.noOrder(props.item), noResults: !_vm.hasResults(props.item) }},[_c('td',{staticClass:"text-xs-right",on:{"click":function($event){_vm.openStudy(props.item)}}},[_vm._v(_vm._s(props.item.protocol))]),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){_vm.openStudy(props.item)}}},[_vm._v(_vm._s(props.item.patient.first_name)+" "+_vm._s(props.item.patient.last_name))]),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){_vm.openStudy(props.item)}}},[_vm._v(_vm._s(props.item.patient.dni))]),(props.item.studies)?_c('td',{staticClass:"text-xs-left",on:{"click":function($event){_vm.openStudy(props.item)}}},[(props.item.studies.anemia)?_c('v-chip',{staticClass:"light-green lighten-1 white--text",attrs:{"small":"small"}},[_vm._v("EA")]):_vm._e(),(props.item.studies.anticoagulation)?_c('v-chip',{staticClass:"light-blue white--text",attrs:{"small":"small"}},[_vm._v("EAC")]):_vm._e(),(props.item.studies.hemostasis)?_c('v-chip',{staticClass:"teal lighten-2 white--text",attrs:{"small":"small"}},[_vm._v("CCH")]):_vm._e(),(props.item.studies.myelogram)?_c('v-chip',{staticClass:"deep-purple lighten-3 white--text",attrs:{"small":"small"}},[_vm._v("MD")]):_vm._e(),(props.item.studies.thrombophilia)?_c('v-chip',{staticClass:"orange lighten-2 white--text",attrs:{"small":"small"}},[_vm._v("PT")]):_vm._e(),(props.item.studies.compatibility)?_c('v-chip',{staticClass:"pink lighten-2 white--text",attrs:{"small":"small"}},[_vm._v("PCM")]):_vm._e()],1):_vm._e(),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){_vm.openStudy(props.item)}}},[_vm._v(_vm._s(props.item.patient.medicare))]),_c('td',{staticClass:"text-xs-left",on:{"click":function($event){_vm.openStudy(props.item)}}},[_vm._v(_vm._s(props.item.date))]),_c('td',{staticClass:"text-xs-right"},[_c('v-menu',{attrs:{"bottom":"bottom","left":"left"}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_c('v-list',[(props.item.results.length)?_c('v-list-tile',{on:{"click":function($event){_vm.print(props.item._id)}}},[_c('v-list-tile-title',[_c('v-icon',{staticClass:"mr-4"},[_vm._v("print")]),_vm._v("Imprimir")],1)],1):_vm._e(),(props.item.results.length)?_c('v-list-tile',{on:{"click":function($event){_vm.showEmailPrompt(props.item)}}},[_c('v-list-tile-title',[_c('v-icon',{staticClass:"mr-4"},[_vm._v("email")]),_vm._v("Enviar…")],1)],1):_vm._e(),_c('v-list-tile',{on:{"click":function($event){_vm.openStudy(props.item)}}},[_c('v-list-tile-title',[_c('v-icon',{staticClass:"mr-4"},[_vm._v("mode_edit")]),_vm._v("Editar")],1)],1)],1)],1)],1)])]}}])},[(_vm.totalPages > 1)?_c('template',{slot:"footer"},[_c('td',{attrs:{"colspan":"7"}},[_c('v-pagination',{attrs:{"length":_vm.totalPages,"total-visible":10,"circle":"circle"},model:{value:(_vm.pagination.current),callback:function ($$v) {_vm.$set(_vm.pagination, "current", $$v)},expression:"pagination.current"}})],1)]):_vm._e()],2):_c('div',{staticClass:"loading"},[_c('v-progress-circular',{staticClass:"pink--text",attrs:{"indeterminate":"indeterminate","size":"64"}})],1),_c('v-dialog',{attrs:{"width":"400"},model:{value:(_vm.displayEmailPrompt),callback:function ($$v) {_vm.displayEmailPrompt=$$v},expression:"displayEmailPrompt"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Enviar por correo")])]),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"E-mail","type":"email","hint":"Dirección de correo del destinatario","required":"required","rules":[_vm.validEmail]},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.sendStudy(_vm.study)},"input":function($event){_vm.validEmail = true}},model:{value:(_vm.study.patient.email),callback:function ($$v) {_vm.$set(_vm.study.patient, "email", $$v)},expression:"study.patient.email"}}),_c('v-checkbox',{attrs:{"color":"primary","label":"Recordar correo para este paciente"},model:{value:(_vm.updatePatientEmail),callback:function ($$v) {_vm.updatePatientEmail=$$v},expression:"updatePatientEmail"}})],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{staticClass:"blue-grey--text",attrs:{"flat":"flat"},on:{"click":function($event){_vm.displayEmailPrompt = false}}},[_vm._v("Cancelar")]),_c('v-btn',{staticClass:"primary--text",attrs:{"loading":_vm.sendingEmail,"flat":"flat"},on:{"click":function($event){_vm.sendStudy(_vm.study)}}},[_vm._v("Enviar")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FmJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_study_vue__ = __webpack_require__("67Lx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d95c830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_study_vue__ = __webpack_require__("QLn+");
function injectStyle (ssrContext) {
  __webpack_require__("b7Ub")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_study_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d95c830_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_study_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G2sO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-field",class:{ title: _vm.isTitle }},[(_vm.isInput)?_c('v-text-field',{attrs:{"label":_vm.field.label,"rules":[_vm.validate],"multi-line":_vm.isTextArea,"auto-grow":_vm.isTextArea},model:{value:(_vm.model[_vm.field.name]),callback:function ($$v) {_vm.$set(_vm.model, _vm.field.name, $$v)},expression:"model[field.name]"}},[_c('template',{slot:"label"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.label)}})])],2):_vm._e(),(_vm.isSelect)?_c('v-select',{attrs:{"label":_vm.field.label,"items":_vm.field.options,"item-text":"label","item-value":"value"},model:{value:(_vm.model[_vm.field.name]),callback:function ($$v) {_vm.$set(_vm.model, _vm.field.name, $$v)},expression:"model[field.name]"}},[_c('template',{slot:"label"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.label)}})])],2):_vm._e(),(_vm.isTitle)?_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.field.label))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_ui_store__ = __webpack_require__("MAF5");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  modules: { uiStore: __WEBPACK_IMPORTED_MODULE_2__store_ui_store__["a" /* default */] }
}));

/***/ }),

/***/ "L5/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");






/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])(['setPrintContent']), {
    print: function print(id) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var query, study;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = { $render: true };
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].service('study').get(id, { query: query });

              case 4:
                study = _context.sent;

                _this.setPrintContent(study);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);
                throw _context.t0;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    }
  })
});

/***/ }),

/***/ "MAF5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-param-reassign */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'uiStore',

  state: {
    section: '',
    printContent: '',
    displaySnack: false,
    snackMessage: ''
  },

  getters: {
    section: function section(state) {
      return state.section;
    },
    printContent: function printContent(state) {
      return state.printContent;
    },
    displaySnack: function displaySnack(state) {
      return state.displaySnack;
    },
    snackMessage: function snackMessage(state) {
      return state.snackMessage;
    }
  },

  mutations: {
    setSection: function setSection(state, name) {
      state.section = name;
    },
    setPrintContent: function setPrintContent(state, url) {
      state.printContent = url;
    },
    showSnack: function showSnack(state, text) {
      state.snackMessage = text;
      state.displaySnack = true;

      setTimeout(function () {
        state.displaySnack = false;
      }, 3000);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__("YkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__("gyMJ");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__app__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */]
});

/***/ }),

/***/ "NRKb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QLn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"study"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"card","prominent":"prominent"}},[_c('v-toolbar-title',{staticClass:"light-blue--text subheading"},[_vm._v("Estudio")]),_c('v-spacer'),_c('v-toolbar-title',{staticClass:"subheading protocol-counter"},[_vm._v("Protocolo "+_vm._s(("#" + _vm.protocol)))]),(_vm.isEditing)?_c('v-btn',{attrs:{"icon":"icon"},on:{"click":function($event){_vm.print(_vm.study._id)}}},[_c('v-icon',[_vm._v("print")])],1):_vm._e(),(_vm.isEditing)?_c('v-dialog',{attrs:{"width":"400"},model:{value:(_vm.displayEmailPrompt),callback:function ($$v) {_vm.displayEmailPrompt=$$v},expression:"displayEmailPrompt"}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},slot:"activator"},[_c('v-icon',[_vm._v("email")])],1),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"title"},[_vm._v("Enviar por correo")])]),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"E-mail","type":"email","hint":"Dirección de correo del destinatario","required":"required","rules":[_vm.validEmail]},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.sendStudy(_vm.study)},"input":function($event){_vm.validEmail = true}},model:{value:(_vm.study.patient.email),callback:function ($$v) {_vm.$set(_vm.study.patient, "email", $$v)},expression:"study.patient.email"}}),_c('v-checkbox',{attrs:{"color":"primary","label":"Recordar correo para este paciente"},model:{value:(_vm.updatePatientEmail),callback:function ($$v) {_vm.updatePatientEmail=$$v},expression:"updatePatientEmail"}})],1),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{staticClass:"blue-grey--text",attrs:{"flat":"flat"},on:{"click":function($event){_vm.displayEmailPrompt = false}}},[_vm._v("Cancelar")]),_c('v-btn',{staticClass:"pink--text",attrs:{"loading":_vm.sendingEmail,"flat":"flat"},on:{"click":function($event){_vm.sendStudy(_vm.study)}}},[_vm._v("Enviar")])],1)],1)],1):_vm._e()],1),_c('div',{staticClass:"study__basic-info"},[_c('div',{staticClass:"study__basic-info__field"},[_c('v-select',{attrs:{"autocomplete":"autocomplete","return-object":"return-object","cache-items":"cache-items","required":"required","label":"Paciente","item-text":"label","async-loading":_vm.loading,"search-input":_vm.patientSearchQuery,"items":_vm.patients,"debounce-search":500},on:{"update:searchInput":function($event){_vm.patientSearchQuery=$event}},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_c('div',{staticClass:"item"},[_c('div',{staticClass:"item__title"},[_vm._v(_vm._s(data.item.first_name)+" "+_vm._s(data.item.last_name))]),_c('div',{staticClass:"item__description"},[_vm._v(_vm._s(data.item.dni))])])]}},{key:"selection",fn:function(data){return [_c('div',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(data.item.first_name))])])]}}]),model:{value:(_vm.study.patient),callback:function ($$v) {_vm.$set(_vm.study, "patient", $$v)},expression:"study.patient"}}),(_vm.loading)?_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"indeterminate","size":"24"}}):_vm._e()],1),_c('div',{staticClass:"study__basic-info__field"},[_c('v-text-field',{attrs:{"label":"Medico derivante","required":"required"},model:{value:(_vm.study.medic),callback:function ($$v) {_vm.$set(_vm.study, "medic", $$v)},expression:"study.medic"}})],1),_c('div',{staticClass:"study__basic-info__field"},[_c('v-text-field',{attrs:{"label":"Obra Social","disabled":!_vm.study.patient.value},model:{value:(_vm.study.patient.medicare),callback:function ($$v) {_vm.$set(_vm.study.patient, "medicare", $$v)},expression:"study.patient.medicare"}})],1),_c('div',{staticClass:"study__basic-info__field"},[_c('v-menu',{attrs:{"lazy":"lazy","z-index":"1000"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Fecha de extracción","prepend-icon":"event","readonly":"readonly","required":"required"},slot:"activator",model:{value:(_vm.formattedDate),callback:function ($$v) {_vm.formattedDate=$$v},expression:"formattedDate"}}),_c('v-date-picker',{attrs:{"landscape":"landscape","locale":"es-AR","date-format":_vm.formatDate,"formatted-value":_vm.formattedDate},on:{"update:formattedValue":function($event){_vm.formattedDate=$event}},model:{value:(_vm.studyDate),callback:function ($$v) {_vm.studyDate=$$v},expression:"studyDate"}})],1)],1),_c('div',{staticClass:"study__basic-info__field"},[_c('v-checkbox',{attrs:{"color":"primary","label":"Falta orden/Particular no pago"},model:{value:(_vm.study.noOrder),callback:function ($$v) {_vm.$set(_vm.study, "noOrder", $$v)},expression:"study.noOrder"}})],1),_c('div',{staticClass:"study__basic-info__field study__basic-info__field--full-width"},[_c('v-text-field',{attrs:{"label":"Observaciones","multi-line":"multi-line","auto-grow":"auto-grow"},model:{value:(_vm.study.comment),callback:function ($$v) {_vm.$set(_vm.study, "comment", $$v)},expression:"study.comment"}})],1)]),_c('h5',[_vm._v("Estudios")]),_c('div',{staticClass:"studies"},_vm._l((_vm.studyTypes),function(type,key){return _c('div',{staticClass:"studies__study",class:{ "studies__study--checked": _vm.study.studies[key] }},[_c('v-checkbox',{attrs:{"color":"primary","label":type.label},model:{value:(_vm.study.studies[key]),callback:function ($$v) {_vm.$set(_vm.study.studies, key, $$v)},expression:"study.studies[key]"}})],1)}),0),(_vm.isEditing)?_c('div',{staticClass:"results"},[_c('h5',[_vm._v("Resultados")]),_c('v-tabs',{attrs:{"centered":"centered"},model:{value:(_vm.currentForm),callback:function ($$v) {_vm.currentForm=$$v},expression:"currentForm"}},[_c('v-tabs-bar',{staticClass:"white"},[_vm._l((_vm.study.studies),function(value,key){return (value)?_c('v-tabs-item',{key:key,attrs:{"href":key,"ripple":"ripple"},on:{"click":function($event){_vm.setForm(key)}}},[_vm._v(_vm._s(_vm.formSchemas[key].label))]):_vm._e()}),_c('v-tabs-slider',{staticClass:"primary"})],2),_c('v-tabs-items',_vm._l((_vm.study.results),function(result){return (result)?_c('v-tabs-content',{key:result.type,attrs:{"id":result.type}},[_c('study-form',{attrs:{"form":_vm.formSchemas[result.type],"values":result.data}})],1):_vm._e()}),1)],1)],1):_vm._e(),_c('v-card-actions',[_c('v-btn',{staticClass:"blue-grey--text",attrs:{"flat":"flat"},on:{"click":_vm.cancel}},[_vm._v("Cancelar")]),_c('v-btn',{staticClass:"pink lighten-2 submit-button",attrs:{"dark":"dark","disabled":!_vm.requestedStudies},on:{"click":_vm.save}},[_vm._v("Guardar")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TneL":
/***/ (function(module, exports) {

module.exports = {"name":"compatibility","label":"Compatibilidad Matrimonial","fields":[{"type":"title","label":"Mujer"},{"name":"female_blood_type","label":"Grupo sanguíneo","type":"select","placeholder":"Seleccione un valor","options":[{"value":"a","label":"A"},{"value":"b","label":"B"},{"value":"ab","label":"AB"},{"value":"o","label":"0"}]},{"name":"female_rh0_d_factor","label":"Factor Rh<sub>0</sub> D","type":"select","placeholder":"Seleccione un valor","options":[{"value":"positive","label":"Positivo"},{"value":"negative","label":"Negativo"}]},{"name":"female_genotype","label":"Genotipo más probable","type":"input","placeholder":"Ingrese un valor"},{"name":"female_indirect_coombs","label":"Coombs Indirecta","type":"select","placeholder":"Seleccione un valor","options":[{"value":"positive","label":"Positiva"},{"value":"negative","label":"Negativa"}]},{"type":"title","label":"Hombre"},{"name":"male_blood_type","label":"Grupo sanguíneo","type":"select","placeholder":"Seleccione un valor","options":[{"value":"a","label":"A"},{"value":"b","label":"B"},{"value":"ab","label":"AB"},{"value":"o","label":"0"}]},{"name":"male_rh0_d_factor","label":"Factor Rh<sub>0</sub> D","type":"select","placeholder":"Seleccione un valor","options":[{"value":"positive","label":"Positivo"},{"value":"negative","label":"Negativo"}]},{"name":"male_genotype","label":"Genotipo más probable","type":"input","placeholder":"Ingrese un valor"},{"type":"separator"},{"name":"heterozygosity","label":"Heterocigosidad %","type":"input","placeholder":"Ingrese un valor"},{"name":"homozygosity","label":"Homocigosidad %","type":"input","placeholder":"Ingrese un valor"}]}

/***/ }),

/***/ "UiOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_study_print__ = __webpack_require__("L5/i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_study_send__ = __webpack_require__("wb2x");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',

  data: function data() {
    return {
      displaySearch: false,
      searchQuery: '',
      pagination: {
        current: 1
      },
      study: {
        patient: {},
        results: [],
        studies: {}
      },
      table: {
        isFiltered: false,
        pagination: {
          sortBy: 'protocol',
          descending: true,
          rowsPerPage: 30
        },
        headers: [{ text: 'Protocolo', align: 'right', value: 'protocol' }, { text: 'Nombre', align: 'left', value: 'name' }, { text: 'DNI', align: 'left', value: 'document' }, { text: 'Estudio', align: 'left', value: 'study' }, { text: 'O. Social', align: 'left', value: 'medicare' }, { text: 'Fecha', align: 'left', value: 'date' }, { text: '', align: 'right', value: 'action', sortable: false }]
      }
    };
  },
  created: function created() {
    this.getStudies();
  },


  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])({
    list: 'study/list'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["e" /* mapState */])('study', {
    loading: 'isFindPending'
  }), {
    totalPages: function totalPages() {
      if (!this.pagination.total) return null;
      return Math.ceil(this.pagination.total / this.pagination.limit);
    },
    mustShowSearch: function mustShowSearch() {
      return this.displaySearch || !!this.searchQuery;
    },
    studies: function studies() {
      return this.list.map(function (study) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, study, {
          date: __WEBPACK_IMPORTED_MODULE_4_moment___default()(study.date).format('DD MMM YYYY')
        });
      });
    }
  }),

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapActions */])('study', {
    find: 'find'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapMutations */])('study', {
    clear: 'clearList'
  }), {
    showEmailPrompt: function showEmailPrompt(study) {
      this.study = study;
      this.displayEmailPrompt = true;
    },
    getStudies: function getStudies() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var query;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.clear();

                if (!_this.searchQuery) {
                  _context.next = 19;
                  break;
                }

                query = {
                  $search: {
                    'patient.label': _this.searchQuery,
                    protocol: _this.searchQuery
                  }
                };
                _context.prev = 3;
                _context.t0 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default.a;
                _context.t1 = {};
                _context.t2 = _this.pagination;
                _context.next = 9;
                return _this.find({ query: query });

              case 9:
                _context.t3 = _context.sent;
                _this.pagination = (0, _context.t0)(_context.t1, _context.t2, _context.t3);

                delete _this.pagination.data;
                _this.table.isFiltered = true;
                return _context.abrupt('return');

              case 16:
                _context.prev = 16;
                _context.t4 = _context['catch'](3);
                throw _context.t4;

              case 19:
                _context.prev = 19;
                _context.t5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default.a;
                _context.t6 = {};
                _context.t7 = _this.pagination;
                _context.next = 25;
                return _this.find();

              case 25:
                _context.t8 = _context.sent;
                _this.pagination = (0, _context.t5)(_context.t6, _context.t7, _context.t8);

                delete _this.pagination.data;
                _this.table.isFiltered = false;
                return _context.abrupt('return');

              case 32:
                _context.prev = 32;
                _context.t9 = _context['catch'](19);
                throw _context.t9;

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 16], [19, 32]]);
      }))();
    },
    openStudy: function openStudy(study) {
      var _id = study._id;

      this.$router.push({ name: 'EditStudy', params: { id: _id } });
    },
    noOrder: function noOrder(study) {
      return study.noOrder;
    },
    hasResults: function hasResults(study) {
      return !!study.results.length;
    },
    toggleSearch: function toggleSearch() {
      var _this2 = this;

      this.displaySearch = !this.displaySearch;

      if (this.displaySearch) {
        this.$nextTick(function () {
          return _this2.$refs.search.focus();
        });
      } else if (this.table.isFiltered) {
        this.getStudies();
      }
    },
    clearSearch: function clearSearch() {
      this.searchQuery = '';
      this.getStudies();
    }
  }),

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_study_print__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_study_send__["a" /* default */]],

  watch: {
    'pagination.current': function handlePageChange() {
      var query = {
        $skip: this.pagination.limit * (this.pagination.current - 1)
      };

      if (this.searchQuery) {
        query.$search = this.searchQuery;
      }

      this.clear();
      this.find({ query: query });
    }
  }
});

/***/ }),

/***/ "W+0h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_study_form_vue__ = __webpack_require__("FDdf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2facfcd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_study_form_vue__ = __webpack_require__("mo+t");
function injectStyle (ssrContext) {
  __webpack_require__("NRKb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_study_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2facfcd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_study_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_just_kebab_case__ = __webpack_require__("HzDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_just_kebab_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_just_kebab_case__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_app__ = __webpack_require__("8QQJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_list__ = __webpack_require__("pjeT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_sign_in__ = __webpack_require__("Arnv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_study__ = __webpack_require__("FmJ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__("IcnI");



var _this = this;












__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/app'
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_7__components_sign_in__["a" /* default */],
    name: 'SignIn'
  }, {
    component: __WEBPACK_IMPORTED_MODULE_5__components_app__["a" /* default */],
    name: 'App',
    path: '/app',
    redirect: { name: 'StudyList' },
    children: [{
      component: __WEBPACK_IMPORTED_MODULE_6__components_list__["a" /* default */],
      meta: { auth: true },
      name: 'StudyList',
      path: 'list'
    }, {
      component: __WEBPACK_IMPORTED_MODULE_8__components_study__["a" /* default */],
      meta: { auth: true },
      name: 'NewStudy',
      path: 'study',
      children: [{
        component: __WEBPACK_IMPORTED_MODULE_8__components_study__["a" /* default */],
        meta: { auth: true },
        name: 'EditStudy',
        path: ':id'
      }]
    }]
  }]
});

router.afterEach(function (_ref) {
  var name = _ref.name;
  return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('setSection', __WEBPACK_IMPORTED_MODULE_4_just_kebab_case___default()(name));
});

router.beforeEach(function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!to.meta.auth) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].authenticate().then(function (_ref3) {
              var accessToken = _ref3.accessToken;

              __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].commit('auth/setAccessToken', accessToken);
              return __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].passport.verifyJWT(accessToken);
            }).then(function (token) {
              __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].dispatch('auth/populateUser', token.userId);
              next();
            }).catch(function () {
              return router.replace({ name: 'SignIn' });
            }));

          case 2:
            if (!(to.name === 'SignIn' && __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].state.auth.accessToken)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt('return', router.replace({ name: 'App' }));

          case 4:
            return _context.abrupt('return', next());

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("39ur");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f314f9de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("CBq/");
function injectStyle (ssrContext) {
  __webpack_require__("pajR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_app_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f314f9de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b7Ub":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dyCW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-in"},[_c('v-card',{staticClass:"sign-in__form"},[_c('v-toolbar',{staticClass:"white",attrs:{"card":"card","prominent":"prominent"}},[_c('v-toolbar-title',{staticClass:"light-blue--text subheading"},[_vm._v("Iniciar sesión")])],1),_c('form',{staticClass:"px-3",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.signIn($event)}}},[_c('v-text-field',{attrs:{"label":"Nombre de usuario","required":"required"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_c('v-text-field',{attrs:{"label":"Contraseña","type":"password","required":"required"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_c('v-alert',{attrs:{"error":"error","value":_vm.error}},[_vm._v(_vm._s(_vm.error))])],1),_c('v-btn',{staticClass:"sign-in__submit ma-3",attrs:{"flat":"flat","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.signIn($event)}}},[_vm._v("Sign in")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_feathers__ = __webpack_require__("jBwy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_feathers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_feathers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_feathers_hooks__ = __webpack_require__("ciwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_feathers_hooks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_feathers_hooks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client__ = __webpack_require__("v0re");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_feathers_authentication_client__ = __webpack_require__("t8Qu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_feathers_authentication_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_feathers_authentication_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_socket_io_client__ = __webpack_require__("DmT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_socket_io_client___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_socket_io_client__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_feathers_vuex__ = __webpack_require__("ddF3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_feathers_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_feathers_vuex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");








var socket = __WEBPACK_IMPORTED_MODULE_4_socket_io_client___default()("https://studies-book-api.herokuapp.com", { transports: ['websocket'], timeout: 60000 });

var api = __WEBPACK_IMPORTED_MODULE_0_feathers___default()().configure(__WEBPACK_IMPORTED_MODULE_1_feathers_hooks___default()()).configure(__WEBPACK_IMPORTED_MODULE_2_feathers_socketio_client___default()(socket)).configure(__WEBPACK_IMPORTED_MODULE_3_feathers_authentication_client___default()({ storage: global.localStorage })).configure(__WEBPACK_IMPORTED_MODULE_5_feathers_vuex___default()(__WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */], {
  idField: '_id',
  auth: {
    userService: '/users'
  }
}));

// For every service created, a Vuex store module will be created.
api.service('/users');
api.service('/study');
api.service('/patient');
api.service('/counter');
api.service('/result');
api.service('/mailer');

// Change default timeout for services that hit third party APIs.
api.service('/patient').timeout = 60000;
api.service('/mailer').timeout = 60000;

/* harmony default export */ __webpack_exports__["a"] = (api);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "hCJP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "in8c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mo+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_c('h4',{staticClass:"form__title"},[_vm._v(_vm._s(_vm.form.label))]),_c('div',{staticClass:"form__fields"},_vm._l((_vm.form.fields),function(field){return _c('form-field',{key:field.name,attrs:{"field":field,"form-type":_vm.form.name,"model":_vm.values},on:{"update:model":function($event){_vm.values=$event}}})}),1),_c('div',{staticClass:"form__extra"},[_c('h4',{staticClass:"headline"},[_vm._v("Comentarios y Conclusión")]),_c('form-field',{attrs:{"field":_vm.comments,"form-type":_vm.form.name,"model":_vm.values},on:{"update:model":function($event){_vm.values=$event}}}),_c('form-field',{attrs:{"field":_vm.conclusion,"form-type":_vm.form.name,"model":_vm.values},on:{"update:model":function($event){_vm.values=$event}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "optV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p0zs":
/***/ (function(module, exports) {

module.exports = {"name":"anemia","label":"Estudio de Anemia","fields":[{"name":"rbc","label":"Hematíes x 10<sup>6</sup>/µL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"4,7 – 6,1","female":"4,2 – 5,4","child":"4,6"}},{"name":"hematocrit","label":"Hematócrito %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"42 – 48","female":"37 – 44","child":"–"}},{"name":"hemoglobin","label":"Hemoglobina grs./dL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"13,5 – 16,5","female":"12 – 15","child":"–"}},{"name":"reticulocytes","label":"Reticulocitos %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"0,1 – 1,5","female":"–","child":"–"}},{"name":"vcm","label":"VCM fL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"82 – 95","female":"–","child":"–"}},{"name":"hcm","label":"HCM pg","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"27 – 32","female":"–","child":"–"}},{"name":"chcm","label":"CHCM %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"32 – 35","female":"–","child":"–"}},{"name":"rdw_sd","label":"RDW SD fL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"39 – 46","female":"–","child":"–"}},{"name":"rdw_cv","label":"RDW CV %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"11,6 – 14,6","female":"–","child":"–"}},{"name":"vmp","label":"VPM fL","unit":"fL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"8.5 – 10.5","female":"8.5 – 10.5","child":"8.5 – 10.5"}},{"name":"serum_iron","label":"Ferremia (sideremia) µg/dL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"50 – 150","female":"–","child":"–"}},{"name":"tibc_transferrin","label":"TIBC (transferrina) µg/dL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"240 – 450","female":"–","child":"–"}},{"name":"transferrin_saturation","label":"Saturación de Transferrina %","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"20 – 50","female":"–","child":"–"}},{"name":"leukocytes","label":"Leucocitos x 10<sup>3</sup>/µL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"4,4 – 7,4","female":"–","child":"–"}},{"name":"ESR","label":"Eritrosedimentación mm","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"4,4 – 7,4","female":"–","child":"–"}},{"name":"platelets","label":"Plaquetas x 10<sup>3</sup>/µL","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"190 – 400","female":"–","child":"–"}},{"name":"direct_coombs","label":"Coombs Directa","type":"select","placeholder":"Seleccione un valor","options":[{"value":"positive","label":"Positiva"},{"value":"negative","label":"Negativa"}]},{"name":"differential_leukocyte_count","label":"Leucocitos Recuento Diferencial","type":"title-input","unit":"%","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$"},{"name":"neutrophil_rabbles","label":"Neutrófilos en Cayado","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"1 – 3","female":"–","child":"–"}},{"name":"segmented_neutrophils","label":"Neutrófilos Segmentados","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"–","female":"–","child":"–"}},{"name":"eosinophils","label":"Eosinófilos","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"1 – 4","female":"–","child":"–"}},{"name":"basophils","label":"Basófilos","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"–","female":"–","child":"–"}},{"name":"monocytes","label":"Monocitos","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"2 – 8","female":"–","child":"–"}},{"name":"immature_blasts","label":"Formas Inmaduras - Blastos","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"–","female":"–","child":"–"}},{"name":"lymphocytes","label":"Linfocitos","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"20 – 40","female":"–","child":"–"}}]}

/***/ }),

/***/ "pajR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pjeT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("UiOb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223c2ef1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("FKt4");
function injectStyle (ssrContext) {
  __webpack_require__("optV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_223c2ef1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pnYW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      studyTypes: {
        anticoagulation: { label: 'Anticoagulación', selected: false },
        anemia: { label: 'Estudio de Anemia', selected: false },
        compatibility: { label: 'Compatibilidad Matrimonial', selected: false },
        hemostasis: { label: 'Hemostasia', selected: false },
        myelogram: { label: 'Mielograma Descriptivo', selected: false },
        thrombophilia: { label: 'Estudio de Trombofilia', selected: false }
      }
    };
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wb2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__("gyMJ");




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      displayEmailPrompt: false,
      sendingEmail: false,
      updatePatientEmail: false,
      validEmail: true
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['showSnack']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('mailer', {
    sendEmail: 'create'
  }), {
    sendStudy: function sendStudy(study) {
      var _this = this;

      var patient = study.patient,
          _id = study._id;

      var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!patient.email) {
        this.validEmail = 'Requerido';
        return;
      }

      if (!pattern.test(patient.email)) {
        this.validEmail = 'E-mail inválido';
        return;
      }

      var payload = { to: patient.email, studyId: _id };
      this.sendingEmail = true;

      this.sendEmail(payload).then(function () {
        _this.sendingEmail = false;
        _this.displayEmailPrompt = false;
        _this.showSnack('Estudio enviado');
      }).catch(function (e) {
        _this.sendingEmail = false;
        _this.showSnack('Falló al enviar');
        throw e;
      });

      if (this.updatePatientEmail) {
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].service('study').patch(_id, study);
      }
    }
  })
});

/***/ }),

/***/ "zYdx":
/***/ (function(module, exports) {

module.exports = {"name":"thrombophilia","label":"Estudio de Trombofilia","showMethod":true,"fields":[{"name":"quick","label":"Tiempo de Protrombina (Quick)","type":"input","unit":"seg","method":"Quick","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"10 – 15"},{"name":"percentage","label":"Porcentaje","type":"input","unit":"%","method":"Quick","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 130"},{"name":"rin","label":"R.I.N.","type":"input","unit":"seg","method":"Quick","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"0.8 – 1.2"},{"name":"aptt","label":"aPTT","type":"input","unit":"seg","method":"Coagulométrico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"26 – 40"},{"name":"fibrinogen","label":"Fibrinógeno","type":"input","unit":"g/l","method":"Clauss","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"1.8 – 4"},{"name":"overall_protein_C_system","label":"Resistencia a la Proteína C Activada","type":"input","method":"Dhalback Modificado","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"Razón normalizada > 0.80"},{"name":"factor5_protein_C_system","label":"Sistema de la Proteína C, Factor V","type":"input","method":"Coagulométrico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"Razón normalizada > 0.70"},{"name":"normalized_protein_C","label":"Proteína C, Razón Normalizada","type":"input","unit":"%","method":"Cromogénico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 140"},{"name":"functional_protein_C","label":"Proteína C Funcional","type":"input","unit":"%","method":"Cromogénico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 140"},{"name":"free_protein_S","label":"Proteína S Libre","type":"input","unit":"%","method":"Turbidimétrico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":{"male":"65 – 125","female":"60 – 110","child":"–"}},{"name":"antithrombin_3","label":"Antitrombina III","type":"input","unit":"%","method":"Cromogénico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"90 – 128"},{"name":"lupus_anticoagulant_APTT","label":"Antic. Lúpico, APTT","type":"input","unit":"seg","method":"Coagulométrico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"26 – 38"},{"name":"lupus_anticoagulant_screening","label":"Antic. Lúpico Screening","type":"input","unit":"seg","method":"dRVVT","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 44"},{"name":"lupus_anticoagulant_confirmatory","label":"Antic. Lúpico Confirmatorio","type":"input","unit":"seg","method":"dRVVT","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 39"},{"name":"lupus_anticoagulant_normalized","label":"Antic. Lúpico, Razón Normalizada","type":"input","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 1.20"},{"name":"lupus_anticoagulant_TTI","label":"Antic. Lúpico, Índice de TTI","type":"input","method":"TTI","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 1.30"},{"name":"class_IgM_gpi_antibeta2_antibodies","label":"Anticuerpos Anti beta2 GPI Clase IgM","type":"input","unit":"U/ml","method":"ELISA","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 20"},{"name":"class_IgG_gpi_antibeta2_antibodies","label":"Anticuerpos Anti beta2 GPI Clase IgG","type":"input","unit":"U/ml","method":"ELISA","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 20"},{"name":"class_IgM_anticardiolipin_antibodies","label":"Anticuerpos Anticardiolipina Clase IgM","type":"input","unit":"U/ml","method":"ELISA","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 12.5"},{"name":"class_IgG_anticardiolipin_antibodies","label":"Anticuerpos Anticardiolipina Clase IgG","type":"input","unit":"U/ml","method":"ELISA","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 15"},{"name":"pai_4g-5g","label":"PAI 4G/5G","type":"input","unit":"µmol/l","method":"PCR","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 16"},{"name":"homocysteine","label":"Homocisteína","type":"input","unit":"µmol/l","method":"Fluorescencia","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"< 16"},{"name":"factor8","label":"Factor VIII","type":"input","method":"Coagulométrico","pattern":"^(?:[1-9]\\d*|0)?(?:\\.\\d+)?$","placeholder":"Ingrese un valor","reference":"70 – 140"},{"name":"leiden_factor","label":"Factor V. Leiden","type":"select","method":"PCR","placeholder":"Seleccione un valor","options":[{"value":"presents","label":"Presenta"},{"value":"not_present","label":"No presenta"}]},{"name":"20210ga_prothrombin","label":"Protrombina 20210 G-A","type":"select","method":"PCR","placeholder":"Seleccione un valor","options":[{"value":"presents","label":"Presenta"},{"value":"not_present","label":"No presenta"}]}]}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.68c498daa658a12908ba.js